/**
 * Cosmic Size Guide Toggle Engine
 * Premium Modal Interactions
 */

class CosmicSizeGuide {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('#size-guide-trigger');
      if (trigger) {
        e.preventDefault();
        this.open();
        return;
      }

      const closeBtn = e.target.closest('#size-guide-close');
      if (closeBtn) {
        e.preventDefault();
        this.close();
        return;
      }

      const modal = document.getElementById('cosmic-size-guide-modal');
      if (modal && e.target === modal) {
        this.close();
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      const modal = document.getElementById('cosmic-size-guide-modal');
      if (e.key === 'Escape' && modal && modal.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    const modal = document.getElementById('cosmic-size-guide-modal');
    if (!modal) return;
    modal.classList.add('active');
    modal.style.opacity = '';
    modal.style.visibility = '';
    document.body.style.overflow = 'hidden'; // Prevent scroll
  }

  close() {
    const modal = document.getElementById('cosmic-size-guide-modal');
    if (!modal) return;
    modal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scroll
  }
}

// Global initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.cosmicSizeGuideInstance = new CosmicSizeGuide();
  });
} else {
  window.cosmicSizeGuideInstance = new CosmicSizeGuide();
}
